/**
 * RENDERING: GameRenderer
 * Renderer principale che coordina tutti i rendering
 */

import { PacmanState, Ghost } from '../types/GameTypes'
import { COLORS } from '../types/GameConstants'
import { MazeRenderer } from './MazeRenderer'
import { PacmanRenderer } from './PacmanRenderer'
import { GhostRenderer } from './GhostRenderer'
import { UIRenderer } from './UIRenderer'

export class GameRenderer {
  static render(
    ctx: CanvasRenderingContext2D,
    maze: number[][],
    dots: Set<string>,
    powerPellets: Set<string>,
    pacman: PacmanState,
    pacmanMouth: number,
    ghosts: Ghost[],
    frightenedTimer: number,
    score: number,
    lives: number,
    level: number,
    width: number,
    height: number
  ) {
    // Clear canvas
    ctx.fillStyle = COLORS.BACKGROUND
    ctx.fillRect(0, 0, width, height)

    // Render maze, dots and power pellets
    MazeRenderer.render(ctx, maze, dots, powerPellets)

    // Render ghosts
    GhostRenderer.render(ctx, ghosts, frightenedTimer)

    // Render Pacman
    PacmanRenderer.render(ctx, pacman, pacmanMouth)

    // Render UI
    UIRenderer.render(ctx, score, lives, level, width)
  }
}
